import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SERVICES } from "@/data/site";
import { ArrowUpRight } from "lucide-react";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-28 lg:py-40 border-t border-border">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <span className="font-mono text-xs tracking-[0.35em] text-primary uppercase">03 — Our Services</span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display font-medium text-4xl lg:text-7xl tracking-tight leading-none">
                Services
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-muted-foreground text-base">
              A complete metal manufacturing suite — from raw sheet to finished, assembled component.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border border border-border">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={(i % 4) * 0.06}>
              <motion.div
                whileHover={{ backgroundColor: "hsl(var(--primary))" }}
                transition={{ duration: 0.25 }}
                className="group relative h-full bg-background p-8 min-h-[240px] flex flex-col justify-between overflow-hidden"
                data-testid={`service-card-${s.id}`}
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-sm text-primary group-hover:text-primary-foreground transition-colors">{s.id}</span>
                  <ArrowUpRight className="w-5 h-5 text-muted-foreground group-hover:text-primary-foreground group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300" />
                </div>
                <div>
                  <h3 className="font-display text-xl lg:text-2xl font-semibold leading-tight group-hover:text-primary-foreground transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-muted-foreground leading-relaxed group-hover:text-primary-foreground/85 transition-colors">
                    {s.desc}
                  </p>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
